module.exports = __webpack_public_path__ + "static/img/winter_jianjiePic.e2429805.png";